export const FETCH_TITTLE_SUCCESS = "FETCH_TITTLE_SUCCESS";
export const FETCH_TITTLE_FAIL = "FETCH_TITTLE_FAIL";
export const FETCH_COMMENT_SUCCESS = "FETCH_COMMENT_SUCCESS";
export const FETCH_COMMENT_FAIL = "FETCH_COMMENT_FAIL";

